import React from 'react'
import { useAlert } from '../../../../../../context/AlertContext';
import voucherServices from '../voucherServices';
import VoucherContentSection from '../inline/VoucherContentSection';


function VoucherFooter({voucherDetails,companyDetails,partyDetails,getVoucherDetails, isPrinting}) {

    const {AppAlert} = useAlert();
    const updateVoucherDetails = (payload) =>{
        payload.id = voucherDetails.id;
        console.log(payload);
        voucherServices.save(payload).then(res=>{
        AppAlert("Voucher Details updated");
            getVoucherDetails();
        }).catch(error=>{
        console.log(error);
        })
    }


  return (
    voucherDetails && companyDetails && partyDetails &&
    <div className='row'>
        {voucherDetails.narration !== "" &&
            <div className='col-12' >
                <VoucherContentSection 
                  caption={"Terms & Decleration"}
                  field={"narration"}
                  value={voucherDetails?.narration}
                  callBack={updateVoucherDetails}
                  isPrinting={isPrinting}
                />
                
            </div>
        }
        <div className='col-6'>
            <table className='table table-striped table-bordered table-sm' style={{fontSize:12}}>
                <thead>
                    <tr>
                        <th colSpan={2} className='text-center'>
                            Company's Bank Details
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>A/C Holder Name</td>
                        <th>{companyDetails.bankAccountHolderName}</th>
                    </tr>
                    <tr>
                        <td>Bank Name</td>
                        <th>{companyDetails.bankName}</th>
                    </tr>
                    <tr>
                        <td>Account Number</td>
                        <th>{companyDetails.bankAccountNumber}</th>
                    </tr>
                    <tr>
                        <td>Branch & Ifsc</td>
                        <th>{companyDetails.bankBranch} {companyDetails.bankIfsc}</th>
                    </tr>

                    <tr>
                        <td>SWIFT Code</td>
                        <th>{companyDetails.bankSwift}</th>
                    </tr>

                    
                </tbody>
            </table>
        </div>

        <div className='col-6'>
            <table className='table table-sm' style={{fontSize:12}}>
                <tbody>
                    <tr>
                        <td>Company's Pan</td>
                        <th>{companyDetails.pan}</th>
                    </tr>
                    
                </tbody>
            </table>
            <div className='card' style={{fontSize:12}}>
                <div className='card-body p-1'>
                <div className='float-end'>
                    <div className='fw-bold'>for {companyDetails.companyName}</div>
                    <img src={companyDetails.authSign} style={{ maxWidth:".75in",maxHeight:".75in",}} />
                    <div>Authorised Signatory</div>
                </div>
                </div>
            </div>
        </div>
        {/* <div className='col-md-12 text-center' style={{fontSize:12}}>This is a Computer Generated Voucher</div> */}
    </div>
  )
}

export default VoucherFooter